<template>
  <div class="tps-card">
    <div class="tps-header">
      <div class="tps-header-left">
        <i class="ti ti-sparkles" aria-hidden="true"></i>
        <span>Which payroll run to check?</span>
      </div>
    </div>

    <div class="tps-body">
      <div class="tps-hint">
        {{ data.hint || 'Select the payroll run you want to check for anomalies. TARA will compare it against the previous run of the same type.' }}
      </div>

      <!-- Group runs by period -->
      <div
        v-for="(group, period) in groupedRuns"
        :key="period"
        class="tps-period"
      >
        <div class="tps-period-label">{{ periodLabel(group[0]) }}</div>
        <div
          v-for="run in group"
          :key="run.poid"
          class="tps-run-row"
          :class="{ selected: selectedPoid === run.poid }"
          @click="selectRun(run)"
        >
          <div class="tps-run-info">
            <div class="tps-run-name">{{ run.payoutdesc }}</div>
            <div class="tps-run-sub">
              {{ run.payrolltypedesc }}
              <span v-if="run.valvaluedesc"> · {{ run.valvaluedesc }}</span>
            </div>
          </div>
          <span class="tps-status-badge" :class="statusClass(run.pystatuscode)">
            {{ run.pystatusdesc || statusLabel(run.pystatuscode) }}
          </span>
          <i class="ti ti-chevron-right tps-arrow" aria-hidden="true"></i>
        </div>
      </div>

      <div v-if="!data.runs || data.runs.length === 0" class="tps-empty">
        No payroll runs found. Please process a payroll run first.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaraPayrollSelectCard",
  props: {
    data: { type: Object, required: true },
  },
  data() {
    return { selectedPoid: null };
  },
  computed: {
    groupedRuns() {
      const groups = {};
      for (const run of (this.data.runs || [])) {
        const key = `${run.pyyear}-${String(run.pymonth).padStart(2,'0')}`;
        if (!groups[key]) groups[key] = [];
        groups[key].push(run);
      }
      return groups;
    },
  },
  methods: {
    periodLabel(run) {
      const months = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return `${months[run.pymonth] || run.pymonth} ${run.pyyear}`;
    },
    statusClass(code) {
      if (code == 99) return 'tps-status-final';
      if (code == 20) return 'tps-status-progress';
      return 'tps-status-initial';
    },
    statusLabel(code) {
      if (code == 99) return 'Finalized';
      if (code == 20) return 'In Progress';
      return 'Initial';
    },
    selectRun(run) {
      this.selectedPoid = run.poid;
      // Emit ask event — sends a new message with the poid embedded
      // The Vue component passes it via the store/payload
      this.$emit('select-payroll', {
        poid:        run.poid,
        payoutdesc:  run.payoutdesc,
        pyyear:      run.pyyear,
        pymonth:     run.pymonth,
      });
    },
  },
};
</script>

<style scoped>
.tps-card { border:0.5px solid #AFA9EC; border-radius:12px; background:#FAFAFE; overflow:hidden; font-family:inherit; font-size:13px; margin:4px 0 8px; max-width:400px; }
.tps-header { display:flex; align-items:center; gap:8px; padding:10px 14px 8px; background:#EEEDFE; border-bottom:0.5px solid #AFA9EC; }
.tps-header-left { display:flex; align-items:center; gap:6px; font-weight:500; color:#3C3489; font-size:13px; }
.tps-header-left i { font-size:15px; }
.tps-body { padding:10px 0 4px; }
.tps-hint { font-size:12px; color:#7F77DD; padding:0 14px 10px; line-height:1.5; }
.tps-period { margin-bottom:8px; }
.tps-period-label { font-size:11px; font-weight:500; color:#7F77DD; text-transform:uppercase; letter-spacing:0.05em; padding:4px 14px 4px; background:#F5F4FD; border-top:0.5px solid #E5E3F8; border-bottom:0.5px solid #E5E3F8; }
.tps-run-row { display:flex; align-items:center; gap:8px; padding:10px 14px; border-bottom:0.5px solid #F0EFF9; cursor:pointer; transition:background 0.1s; }
.tps-run-row:hover { background:#EEEDFE; }
.tps-run-row.selected { background:#EEEDFE; border-left:3px solid #534AB7; }
.tps-run-row:last-child { border-bottom:none; }
.tps-run-info { flex:1; min-width:0; }
.tps-run-name { font-size:12px; font-weight:500; color:#26215C; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.tps-run-sub { font-size:10px; color:#7F77DD; margin-top:1px; }
.tps-status-badge { font-size:10px; font-weight:500; padding:2px 7px; border-radius:20px; flex-shrink:0; white-space:nowrap; }
.tps-status-final    { background:#EAF3DE; color:#27500A; }
.tps-status-progress { background:#FAEEDA; color:#633806; }
.tps-status-initial  { background:#E6F1FB; color:#0C447C; }
.tps-arrow { font-size:14px; color:#AFA9EC; flex-shrink:0; }
.tps-empty { padding:16px 14px; font-size:12px; color:#7F77DD; text-align:center; }
</style>
